import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export var ScreeningQuestionsRoutes = {
    "/screening-questions/create?brand_id&is_settings&template_id&edit_mode": {
        "name": "appLayout.harriSH.create-screening-questions",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job_create"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/screening-questions/screening-questions.module.js");
                }
            }
        ]
    },

    [`/screening-questions/create/${hmapPathParamRegex}?brand_id&is_settings&template_id&edit_mode`]: {
        "name": "appLayout.harriSH.access-portal.create-screening-questions",
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job_create"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/screening-questions/screening-questions.module.js");
                }
            }
        ]
    },
};
